import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/pro/pro.scss.shim.ngstyle.ts